import type { NewsfeedPost } from '@/entities/newsfeedPost'
import useIndexSearch from './useIndexSearch'

export type NewsfeedTypeParam = 'all' | 'vrified' | 'following'
export interface NewsfeedParameters {
  type: NewsfeedTypeParam
  query: string
  limit: number
  page?: number
  companyId?: number
  clientVal?: boolean
}
export interface ComputedParameters {
  query?: string
  limit: number
  sort_by?: 'date'
  sort_direction?: 'desc'
  include?: string[]
  offset?: number
  is_vrified?: boolean
}

export default function useNewsfeedSearch(initParameters: Partial<NewsfeedParameters>) {
  let indexSearch = useIndexSearch<NewsfeedPost, NewsfeedParameters, ComputedParameters>({
    initParams: {
      type: 'all',
      limit: 10,
      ...initParameters,
    },
    endpoint(parameters) {
      if (parameters.type === 'following') {
        return 'v2/user/companies/following/posts'
      }
      if (Number.isInteger(parameters.companyId)) {
        return `v2/companies/${parameters.companyId}/posts`
      }
      return 'v2/posts'
    },
    finalParameters(parameters) {
      const finalParams: Partial<ComputedParameters> = {
        sort_by: 'date',
        sort_direction: 'desc',
        include: ['company', 'deck'],
      }

      if (parameters.query && parameters.query !== '') {
        finalParams.query = parameters.query
      }

      if (parameters.type === 'vrified') {
        finalParams.is_vrified = true
      }

      return finalParams as ComputedParameters
    },
  })

  return indexSearch
}
